export type BridgeMessageTypeKeys =
  | 'READY'
  | 'MAITRED_REQUEST'
  | 'SESSION_START'
  | 'SESSION_END'
  | 'MAKE_PAYMENT'
  | 'GO_HOME'
  | 'EXECUTE_PRINT_JOBS'
  | 'PRINT_RECEIPT'
  | 'ORDER_COMPLETED'
  | 'IMAGE'
  | 'TRACK_EVENT'
  | 'DEVICE_GAZEBO_LOG'
  | 'UPDATED_SESSION_DATA'
  | 'USER_DID_ENTER_CRITICAL_PERIOD'
  | 'USER_DID_LEAVE_CRITICAL_PERIOD'
  | 'USER_DID_FOCUS_ON_TEXT_FIELD'
  | 'USER_DID_FOCUS_OUT_OF_TEXT_FIELD'
  | 'SENT_PAYMENT_TO_MAITRED'
  | 'USER_DID_END_PAYMENT_PROCESS'
  | 'USER_DID_TAP_CANCEL_PAYMENT'
  | 'SEND_ORDER'
  | 'SHOW_NATIVE_TOAST'
  | 'SHOW_REFUNDER'
  | 'ORDER_RECOVERY_IS_READY'
  | 'USER_DID_REQUEST_TO_PRINT_RECEIPT'
  | 'READ_GIFT_CARD'
  | 'CANCEL_READ_GIFT_CARD'
  | 'START_SCANNER'
  | 'STOP_SCANNER'
  | 'SEND_SCANNER_DATA'
  | 'SEND_USERS'
  | 'START_READING_SCALE'
  | 'STOP_READING_SCALE'
  | 'SEND_SCALE_DATA'
  | 'MENU_UPDATE'
  | 'ENABLE_REDUCED_VIEWPORT_HEIGHT'
  | 'DISABLE_REDUCED_VIEWPORT_HEIGHT'
  | 'ENABLE_ZOOM'
  | 'DISABLE_ZOOM'
  | 'SOCKET_REQUEST'
  | 'GET_LRS_TABLE_TRACKER_GATEWAY_IP_ADDRESS';

type GarconExcludedOptions =
  | 'MAITRED_REQUEST'
  | 'GO_HOME'
  | 'PRINT_RECEIPT'
  | 'ORDER_COMPLETED'
  | 'IMAGE'
  | 'TRACK_EVENT'
  | 'UPDATED_SESSION_DATA'
  | 'USER_DID_ENTER_CRITICAL_PERIOD'
  | 'USER_DID_LEAVE_CRITICAL_PERIOD'
  | 'USER_DID_FOCUS_ON_TEXT_FIELD'
  | 'USER_DID_FOCUS_OUT_OF_TEXT_FIELD'
  | 'SENT_PAYMENT_TO_MAITRED'
  | 'USER_DID_END_PAYMENT_PROCESS'
  | 'USER_DID_TAP_CANCEL_PAYMENT'
  | 'SEND_ORDER'
  | 'SHOW_NATIVE_TOAST'
  | 'ORDER_RECOVERY_IS_READY'
  | 'USER_DID_REQUEST_TO_PRINT_RECEIPT';

type FlashExcludedOptions =
  | 'SESSION_START'
  | 'SESSION_END'
  | 'EXECUTE_PRINT_JOBS'
  | 'SEND_SCANNER_DATA'
  | 'SEND_USERS'
  | 'SEND_SCALE_DATA'
  | 'MENU_UPDATE';

export type GarconBridgeMessageKeys = Exclude<BridgeMessageTypeKeys, GarconExcludedOptions>;
export type GarconBridgeMessageValues =
  (typeof GarconBridgeMessage)[keyof typeof GarconBridgeMessage];
export const GarconBridgeMessage: Record<GarconBridgeMessageKeys, string> = {
  READY: 'ready',
  SESSION_START: 'session-start',
  SESSION_END: 'session-end',
  SHOW_REFUNDER: 'show-refunder',
  MAKE_PAYMENT: 'make-payment',
  EXECUTE_PRINT_JOBS: 'execute-print-jobs',
  DEVICE_GAZEBO_LOG: 'device-gazebo-log',
  READ_GIFT_CARD: 'read-gift-card',
  CANCEL_READ_GIFT_CARD: 'cancel-read-gift-card',
  START_SCANNER: 'start-scanner',
  STOP_SCANNER: 'stop-scanner',
  SEND_SCANNER_DATA: 'send-scanner-data',
  SEND_USERS: 'send-users',
  START_READING_SCALE: 'start-reading-scale',
  STOP_READING_SCALE: 'stop-reading-scale',
  SEND_SCALE_DATA: 'send-scale-data',
  MENU_UPDATE: 'menu-update',
  ENABLE_REDUCED_VIEWPORT_HEIGHT: 'enable-reduced-viewport-height',
  DISABLE_REDUCED_VIEWPORT_HEIGHT: 'disable-reduced-viewport-height',
  ENABLE_ZOOM: 'enable-zoom',
  DISABLE_ZOOM: 'disable-zoom',
  SOCKET_REQUEST: 'socket-request',
  GET_LRS_TABLE_TRACKER_GATEWAY_IP_ADDRESS: 'get-lrs-table-tracker-gateway-ip-address',
};

export type FlashBridgeMessageKeys = Exclude<BridgeMessageTypeKeys, FlashExcludedOptions>;
export type FlashBridgeMessageValues = (typeof FlashBridgeMessage)[keyof typeof FlashBridgeMessage];
export const FlashBridgeMessage: Record<FlashBridgeMessageKeys, string> = {
  READY: 'ready',
  MAITRED_REQUEST: 'maitredRequest',
  GO_HOME: 'goHome',
  MAKE_PAYMENT: 'makePayment',
  PRINT_RECEIPT: 'printReceipt',
  ORDER_COMPLETED: 'orderCompleted',
  IMAGE: 'image',
  TRACK_EVENT: 'trackEvent',
  DEVICE_GAZEBO_LOG: 'deviceGazeboLog',
  UPDATED_SESSION_DATA: 'updateSessionData',
  USER_DID_ENTER_CRITICAL_PERIOD: 'userDidEnterCriticalPeriod',
  USER_DID_LEAVE_CRITICAL_PERIOD: 'userDidLeaveCriticalPeriod',
  USER_DID_FOCUS_ON_TEXT_FIELD: 'userDidFocusOnTextField',
  USER_DID_FOCUS_OUT_OF_TEXT_FIELD: 'userDidFocusOutOfTextField',
  SENT_PAYMENT_TO_MAITRED: 'sentPaymentToMaitred',
  USER_DID_END_PAYMENT_PROCESS: 'userDidEndPaymentProcess',
  USER_DID_TAP_CANCEL_PAYMENT: 'userDidTapCancelPayment',
  SEND_ORDER: 'sendOrder',
  ORDER_RECOVERY_IS_READY: 'orderRecoveryIsReady',
  USER_DID_REQUEST_TO_PRINT_RECEIPT: 'userDidRequestToPrintReceipt',
  READ_GIFT_CARD: 'readGiftCard',
  CANCEL_READ_GIFT_CARD: 'cancelReadGiftCard',
  SHOW_NATIVE_TOAST: 'show-native-toast',
  SHOW_REFUNDER: 'showRefunder',
  START_SCANNER: 'startScanner',
  STOP_SCANNER: 'stopScanner',
  START_READING_SCALE: 'startReadingScale',
  STOP_READING_SCALE: 'stopReadingScale',
  ENABLE_REDUCED_VIEWPORT_HEIGHT: 'enableReducedViewportHeight',
  DISABLE_REDUCED_VIEWPORT_HEIGHT: 'disableReducedViewportHeight',
  ENABLE_ZOOM: 'enableZoom',
  DISABLE_ZOOM: 'disableZoom',
  SOCKET_REQUEST: 'socketRequest',
  GET_LRS_TABLE_TRACKER_GATEWAY_IP_ADDRESS: 'getLrsTableTrackerGatewayIpAddress',
};
